<div *ngIf="!creating; else spinner">
    <ng-container *ngIf="route.children[1].children[0].params | async; let params">
        <app-dialog-header [title]="params.type !== 'e-learning' ? 'MODULE.NEW' : 'MODULE.NEW_ELEARNING'" (onClick)="dialogRef.close(null)"></app-dialog-header>
    </ng-container>

    <div
        mat-dialog-content
        fxLayout="column"
        fxLayoutAlign="start"
        [class.allow-tags-overflow]="stepper?.selectedIndex === 0 && isStepOneActive"
        *ngIf="route.children[1].children[0].params | async; let params"
        [ngSwitch]="params.type"
    >
        <div id="choose-module-type-container" fxLayout="row wrap" fxLayoutAlign="start" [@animateStagger]="{ value: '50' }" *ngSwitchCase="'choose'">
            <div class="card mb-24" fxFlex="1 1 50%">
                <a [routerLink]="['', { outlets: { modal: ['new-module', 'basic'] } }]">
                    <div class="white h-100-p p-16">
                        <mat-icon svgIcon="course"></mat-icon>
                        <span class="card-title">{{ 'NAV.NEW.MODULE.TITLE' | translate }}</span>
                        <span class="card-description">{{ 'NAV.NEW.MODULE.DESCRIPTION' | translate }}</span>
                    </div>
                </a>
            </div>
            <div class="card mb-24" fxFlex="1 1 50%" *ngIf="isPrivateVisible">
                <a [routerLink]="['', { outlets: { modal: ['new-module', 'private'] } }]">
                    <div class="white h-100-p p-16">
                        <mat-icon svgIcon="course_private"></mat-icon>
                        <span class="card-title">{{ 'NAV.NEW.PRIVATE_MODULE.TITLE' | translate }}</span>
                        <span class="card-description">{{ 'NAV.NEW.PRIVATE_MODULE.DESCRIPTION' | translate }}</span>
                    </div>
                </a>
            </div>
            <div class="card mb-24" fxFlex="1 1 50%" *ngIf="isELearningVisible">
                <a [routerLink]="['', { outlets: { modal: ['new-module', 'e-learning'] } }]">
                    <div class="white h-100-p p-16">
                        <mat-icon svgIcon="e_learning"></mat-icon>
                        <span class="card-title">{{ 'NAV.NEW.ELEARNING_MODULE.TITLE' | translate }}</span>
                        <span class="card-description">{{ 'NAV.NEW.ELEARNING_MODULE.DESCRIPTION' | translate }}</span>
                    </div>
                </a>
            </div>
        </div>
        <div *ngSwitchCase="'e-learning'">
            <form *ngIf="moduleDetailsForm" [formGroup]="moduleDetailsForm" class="module w-100-p pt-16 px-24 e-learning-single-step" autocomplete="off">
                <div class="mb-24 w-100-p" fxLayout="column">
                    <mat-radio-group class="self-paced-container" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="20px" formControlName="contentType">
                        <div class="radio-wrapper e-learning-type p-16" [class.selected]="moduleDetailsForm.controls.contentType.value === 'sections'" fxLayout="column">
                            <mat-radio-button [value]="'sections'"></mat-radio-button>
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <img height="48" width="48" src="/assets/icons/ic_sections.svg" />
                                <span class="mt-12">{{ 'SECTION.PLURAL' | translate }} </span>
                            </div>
                        </div>
                        <div class="radio-wrapper e-learning-type p-16" [class.selected]="moduleDetailsForm.controls.contentType.value === 'e_learning_package'" fxLayout="column">
                            <mat-radio-button [value]="'e_learning_package'"></mat-radio-button>
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <img height="48" width="48" src="/assets/icons/ic_e_learning_package.svg" />
                                <span class="mt-12">{{ 'E_LEARNING.TITLE_PACKAGE' | translate }} </span>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>

                <div fxLayout="row" fxLayoutAlign="flex-end center">
                    <mat-form-field class="w-100-p mb-16">
                        <mat-label>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-label>
                        <input matInput name="name" formControlName="name" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
                        <mat-error *ngIf="moduleDetailsForm.controls['name'].errors && moduleDetailsForm.controls['name'].errors['message']">
                            {{ 'ERROR.RESPONSE.' + moduleDetailsForm.controls['name'].errors['message'] | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <p class="m-0">
                    <span class="input-title">{{ 'TAG.PLURAL' | translate }}</span> ({{ 'GENERAL.PROPERTY.OPTIONAL' | translate | lowercase }})
                </p>
                <div class="w-100-p">
                    <mat-form-field class="w-100-p">
                        <input
                            matInput
                            [placeholder]="('TAG.NEW' | translate) + '...'"
                            #tagInput
                            [formControl]="tagCtrl"
                            [matAutocomplete]="auto"
                            [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addTag($event)"
                        />
                    </mat-form-field>
                    <mat-chip-grid class="wrap mb-8" #chipList>
                        <div class="relative" *ngFor="let tag of moduleDetailsForm.value.tags">
                            <mat-chip-row [style.background]="tag.color" [removable]="true" (removed)="removeTag(tag)" [disableRipple]="true">
                                <span #chip>{{ tag.name }}</span>
                                <mat-icon matChipRemove>close</mat-icon>
                            </mat-chip-row>
                            <app-tag-color-card (updated)="tagUpdated($event)" [tag]="tag" [name]="tag.name" [target]="chip"> </app-tag-color-card>
                        </div>
                    </mat-chip-grid>
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="tagSelected($event)">
                        <mat-optgroup [label]="'TAG.NEW' | translate" *ngIf="!tagTermExists && tagCtrl.value">
                            <mat-option [value]="tagCtrl.value"><span [innerHTML]="tagCtrl.value | highlight: tagCtrl.value"></span></mat-option>
                        </mat-optgroup>
                        <mat-optgroup
                            [label]="('GENERAL.SUGGESTIONS' | translate) + ' (' + tags.length + ')'"
                            *ngIf="(filteredTag$ | async) || [] | exclude: moduleDetailsForm.value.tags || []:'id'; let tags"
                        >
                            <mat-option *ngFor="let tag of tags | filterTagsByCategory: 'module'" [value]="tag">
                                <span [innerHTML]="tag.name | highlight: tagCtrl.value"></span>
                            </mat-option>
                        </mat-optgroup>
                    </mat-autocomplete>
                    <mat-hint>{{ 'PAGE.MODULE_FORM.TAB.OVERVIEW.MESSAGE.TAGS_HINT' | translate }} </mat-hint>
                </div>
            </form>
        </div>
        <div *ngSwitchDefault>
            <mat-horizontal-stepper
                class="pt-16 e-learning"
                [class.allow-tags-overflow]="stepper?.selectedIndex === 0 && isStepOneActive"
                labelPosition="bottom"
                #stepper
                [linear]="true"
                [class.stepper-navigation-locked]="!isFirstStepValid"
                [ngSwitch]="params.type"
                [class.select-participants-tab]="stepper?.selectedIndex === (params.type === 'e-learning' ? 1 : 2)"
                (selectionChange)="onStepChange($event)"
            >
                <mat-step *ngSwitchDefault [completed]="isFirstStepValid">
                    <ng-template matStepLabel>{{ 'MOBILE.LABEL.GENERAL' | translate }}</ng-template>
                    <form *ngIf="moduleDetailsForm" [formGroup]="moduleDetailsForm" class="module w-100-p" autocomplete="off">
                        <div fxLayout="row" fxLayoutAlign="flex-end center">
                            <mat-form-field class="w-100-p mb-16">
                                <mat-label>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-label>
                                <input matInput name="name" formControlName="name" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
                                <mat-error *ngIf="moduleDetailsForm.controls['name'].hasError('required')">
                                    {{ 'ERROR.RESPONSE.required' | translate }}
                                </mat-error>
                                <mat-error *ngIf="moduleDetailsForm.controls['name'].errors && moduleDetailsForm.controls['name'].errors['message']">
                                    {{ 'ERROR.RESPONSE.' + moduleDetailsForm.controls['name'].errors['message'] | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <p class="m-0">
                            <span class="input-title">{{ 'TAG.PLURAL' | translate }}</span> ({{ 'GENERAL.PROPERTY.OPTIONAL' | translate | lowercase }})
                        </p>
                        <div class="w-100-p">
                            <mat-form-field class="w-100-p">
                                <input
                                    matInput
                                    [placeholder]="('TAG.NEW' | translate) + '...'"
                                    #tagInput
                                    [formControl]="tagCtrl"
                                    [matAutocomplete]="auto"
                                    [matChipInputFor]="chipList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="true"
                                    (matChipInputTokenEnd)="addTag($event)"
                                />
                            </mat-form-field>
                            <mat-chip-grid class="wrap mb-8" #chipList>
                                <div class="relative" *ngFor="let tag of moduleDetailsForm.value.tags">
                                    <mat-chip-row [style.background]="tag.color" [removable]="true" (removed)="removeTag(tag)" [disableRipple]="true">
                                        <span #chip>{{ tag.name }}</span>
                                        <mat-icon matChipRemove>close</mat-icon>
                                    </mat-chip-row>
                                    <app-tag-color-card (updated)="tagUpdated($event)" [tag]="tag" [name]="tag.name" [target]="chip"> </app-tag-color-card>
                                </div>
                            </mat-chip-grid>
                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="tagSelected($event)">
                                <mat-optgroup [label]="'TAG.NEW' | translate" *ngIf="!tagTermExists && tagCtrl.value">
                                    <mat-option [value]="tagCtrl.value"><span [innerHTML]="tagCtrl.value | highlight: tagCtrl.value"></span></mat-option>
                                </mat-optgroup>
                                <mat-optgroup
                                    [label]="('GENERAL.SUGGESTIONS' | translate) + ' (' + tags.length + ')'"
                                    *ngIf="(filteredTag$ | async) || [] | exclude: moduleDetailsForm.value.tags || []:'id'; let tags"
                                >
                                    <mat-option *ngFor="let tag of tags | filterTagsByCategory: 'module'" [value]="tag">
                                        <span [innerHTML]="tag.name | highlight: tagCtrl.value"></span>
                                    </mat-option>
                                </mat-optgroup>
                            </mat-autocomplete>
                            <mat-hint>{{ 'PAGE.MODULE_FORM.TAB.OVERVIEW.MESSAGE.TAGS_HINT' | translate }} </mat-hint>
                        </div>

                        <div *ngIf="!moduleDetailsForm.controls.selfPaced.value">
                            <div fxLayout="row" fxLayoutAlign="flex-end center">
                                <mat-form-field class="w-100-p">
                                    <input
                                        matInput
                                        name="startDate"
                                        [max]="maxDate"
                                        formControlName="startDate"
                                        [matDatepicker]="pickerStartDate"
                                        [placeholder]="'GENERAL.PROPERTY.START_DATE' | translate"
                                        (focus)="pickerStartDate.open()"
                                        (ngModelChange)="updateEndDate()"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerStartDate></mat-datepicker>

                                    <mat-error *ngIf="moduleDetailsForm.controls['startDate'].hasError('required')">
                                        {{ 'ERROR.RESPONSE.required' | translate }}
                                    </mat-error>
                                    <mat-error *ngIf="moduleDetailsForm.controls['startDate'].errors && moduleDetailsForm.controls['startDate'].errors['message']">
                                        {{ 'ERROR.RESPONSE.' + moduleDetailsForm.controls['startDate'].errors['message'] | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="flex-end center">
                                <mat-form-field class="w-100-p">
                                    <input
                                        matInput
                                        name="endDate"
                                        [min]="minDate"
                                        formControlName="endDate"
                                        [matDatepicker]="pickerEndDate"
                                        [placeholder]="'GENERAL.PROPERTY.END_DATE' | translate"
                                        (focus)="pickerEndDate.open()"
                                        (dateChange)="updateStartDate()"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerEndDate></mat-datepicker>
                                    <mat-error *ngIf="moduleDetailsForm.controls['endDate'].hasError('required')">
                                        {{ 'ERROR.RESPONSE.required' | translate }}
                                    </mat-error>
                                    <mat-error *ngIf="moduleDetailsForm.controls['endDate'].errors && moduleDetailsForm.controls['endDate'].errors['message']">
                                        {{ 'ERROR.RESPONSE.' + moduleDetailsForm.controls['endDate'].errors['message'] | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="mb-24 w-100-p" fxLayout="column" *ngIf="params.type === 'e-learning'">
                            <mat-radio-group
                                class="self-paced-container"
                                fxLayout="row"
                                fxLayout.xs="column"
                                fxLayoutAlign="center"
                                fxLayoutGap="20px"
                                formControlName="contentType"
                            >
                                <div class="radio-wrapper e-learning-type p-16" [class.selected]="moduleDetailsForm.controls.contentType.value === 'sections'" fxLayout="column">
                                    <mat-radio-button [value]="'sections'"></mat-radio-button>
                                    <div fxLayout="column" fxLayoutAlign="center center">
                                        <img height="48" width="48" src="/assets/icons/ic_sections.svg" />
                                        <span class="mt-12">{{ 'SECTION.PLURAL' | translate }} </span>
                                    </div>
                                </div>
                                <div
                                    class="radio-wrapper e-learning-type p-16"
                                    [class.selected]="moduleDetailsForm.controls.contentType.value === 'e_learning_package'"
                                    fxLayout="column"
                                >
                                    <mat-radio-button [value]="'e_learning_package'"></mat-radio-button>
                                    <div fxLayout="column" fxLayoutAlign="center center">
                                        <img height="48" width="48" src="/assets/icons/ic_e_learning_package.svg" />
                                        <span class="mt-12">{{ 'E_LEARNING.TITLE_PACKAGE' | translate }} </span>
                                    </div>
                                </div>
                            </mat-radio-group>
                        </div>
                    </form>
                </mat-step>

                <mat-step *ngIf="params.type !== 'e-learning'">
                    <ng-template matStepLabel> {{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.CONTENT' | translate }}</ng-template>
                    <form *ngIf="stepper.selectedIndex === 1 && moduleContentForm" [formGroup]="moduleContentForm" class="w-100-p pt-16" fxLayout="column">
                        <mat-radio-group
                            class="structured-module-container"
                            fxLayout="row"
                            fxLayout.xs="column"
                            fxLayoutAlign="center"
                            fxLayoutGap="20px"
                            formControlName="structure"
                            (change)="handleChange($event)"
                        >
                            <div
                                class="radio-wrapper content-structure"
                                fxLayout="column"
                                fxLayoutAlign="center"
                                fxLayoutGap="23px"
                                [class.selected]="moduleContentForm.controls.structure.value"
                            >
                                <mat-radio-button [value]="true"> </mat-radio-button>
                                <div fxLayoutAlign="center center" class="img-wrapper w-100-p py-20">
                                    <mat-icon class="sections-and-content-icon" svgIcon="sections_and_content"></mat-icon>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="center" class="px-16 pb-16">
                                    <span class="center">{{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.SECTIONS_CONTENT' | translate }}</span>
                                    <p>{{ 'COURSES.PROGRAM.CONTENT.SECTIONS_CONTENT' | translate }}</p>
                                </div>
                            </div>
                            <div
                                class="radio-wrapper content-structure"
                                fxLayout="column"
                                fxLayoutAlign="center"
                                fxLayoutGap="23px"
                                [class.selected]="!moduleContentForm.controls.structure.value"
                            >
                                <mat-radio-button [value]="false"> </mat-radio-button>
                                <div fxLayoutAlign="center center" class="img-wrapper w-100-p pb-20">
                                    <mat-icon class="content-only-icon" svgIcon="content_only"></mat-icon>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="center" class="px-16 pb-16">
                                    <span>{{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.CONTENT_ONLY' | translate }}</span>
                                    <p>{{ 'COURSES.PROGRAM.CONTENT.CONTENT_ONLY' | translate }}</p>
                                </div>
                            </div>
                        </mat-radio-group>
                        <mat-divider></mat-divider>
                        <div class="checkbox-wrapper">
                            <mat-radio-group fxLayout="column" formControlName="rule">
                                <mat-radio-button class="mb-0" [value]="ruleOpts.dontTrackProgress">
                                    {{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.DONT_TRACK_PROGRESS' | translate }}
                                </mat-radio-button>
                                <mat-radio-button class="mb-0" [value]="ruleOpts.trackProgress">
                                    {{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.TRACK_PROGRESS' | translate }}
                                </mat-radio-button>
                                <mat-radio-button class="mb-12" [value]="ruleOpts.sequential">
                                    {{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.TRACK_PROGRESS_AND_ENABLE_SEQUENTIAL_ACCESS' | translate }}
                                </mat-radio-button>
                                <span class="text-gray-500">{{ 'FORM.SELECT_CONTENT_STRUCTURE.FIELD.SEQUENTIAL_DESCRIPTION' | translate }}</span>
                            </mat-radio-group>
                        </div>
                    </form>
                </mat-step>
            </mat-horizontal-stepper>

        </div>
        <div
            *ngIf="params.type === 'choose' || moduleDetailsForm"
            mat-dialog-actions
            class="pt-24 px-24 pb-24 action-buttons"
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutGap.xs="20px"
            fxLayoutAlign="space-between center"
            fxLayoutAlign.xs="start space-between"
        >
            <mat-checkbox [(ngModel)]="createAnotherChecked">
                {{ 'MODULE.CREATE_ANOTHER' | translate }}
            </mat-checkbox>
            <div fxLayoutAlign="end center">
                <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(null)" *ngIf="params.type === 'e-learning'"></app-white-button>
                <app-white-button
                    class="mr-8"
                    [label]="'GENERAL.BUTTON.PREVIOUS'"
                    (onClick)="goBack(stepper)"
                    *ngIf="params.type !== 'e-learning' && stepper?.selectedIndex > 0"
                ></app-white-button>
                <app-white-button
                    class="mr-8"
                    [label]="'GENERAL.BUTTON.NEXT'"
                    (onClick)="goForward(stepper)"
                    *ngIf="params.type !== 'e-learning' && (!stepper?.steps || stepper.selectedIndex < stepper.steps.length - 1)"
                ></app-white-button>
                <app-flat-button
                    [label]="'GENERAL.BUTTON.CREATE'"
                    [disabled]="!moduleDetailsForm || moduleDetailsForm.invalid || !moduleDetailsForm.controls?.['name']?.value"
                    (onClick)="create(params.type)"
                ></app-flat-button>
            </div>
        </div>
    </div>
</div>

<ng-template #spinner>
    <div class="p-24" fxLayout="column" fxLayoutAlign="center center">
        <div class="p-24">
            <mat-spinner></mat-spinner>
        </div>
        <p class="center">{{ 'MODULE.MESSAGE.CREATING' | translate }}.<br />{{ 'GENERAL.MESSAGE.PLEASE_WAIT' | translate }}.</p>
    </div>
</ng-template>
